namespace Areas {
    "use strict";

    enum GridMode { Normal, Edit }  

    export class EditButtonsBuilder {
        private readonly addButtonName = "addButton_"+ new DevExpress.data.Guid().toString();
        private readonly editButtonName = "editButton_"+ new DevExpress.data.Guid().toString();
        private readonly deleteButtonName = "deleteButton_"+ new DevExpress.data.Guid().toString(); 
        private readonly saveButtonName = "saveButton_"+ new DevExpress.data.Guid().toString();  
        private readonly cancelButtonName = "cancelButton_"+ new DevExpress.data.Guid().toString(); 

        private readonly grid: DevExpress.ui.dxDataGrid;
        private readonly toolbarOptions: any;
        private gridMode: GridMode = GridMode.Normal;

        constructor(grid: DevExpress.ui.dxDataGrid, toolbarOptions: any) {
            this.grid = grid;
            this.toolbarOptions = toolbarOptions;
        }

        addButtons(buttonOptions: Array<string>) {
            
            let shouldAddSaveButton: boolean = false;
            let trackGridSelection: boolean = false;
            
            if (_.contains(buttonOptions, "add")) {
                this.addAddButton();
                shouldAddSaveButton = true;
            }            
            
            if (_.contains(buttonOptions, "edit")) {
                this.addEditButton();
                shouldAddSaveButton = true;
                trackGridSelection = true;
            }
            
            if (_.contains(buttonOptions, "delete")) {
                this.addDeleteButton();
                shouldAddSaveButton = true;
                trackGridSelection = true;
            }  
            
            if (shouldAddSaveButton) {
                this.addSaveButton();
                this.addCancelButton();
                (this.grid as any).saveRow = this.saveRow(this);
                (this.grid as any).cancelEdit = this.cancelEdit(this);
            }
            
            if (trackGridSelection) {
                this.addTrackGridSelection();
            }

        } 

        private addTrackGridSelection() {
            this.grid.on("selectionChanged", this.onSelectionChanged());
        }
    
        private onSelectionChanged () {
            return (e: any) => {
                const enableEditAndDelete = e.selectedRowKeys.length === 1;
        
                if (enableEditAndDelete) {
                    Areas.enableButton(this.editButtonName);
                    Areas.enableButton(this.deleteButtonName);    
                } else {
                    Areas.disableButton(this.editButtonName);
                    Areas.disableButton(this.deleteButtonName);                
                }
            }
        }

        private addSaveButton() {
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.saveButtonName },
                text: "Save",
                hint: "Save changes",
                type: "success",
                icon: "save",
                visible: false,
                onClick: this.saveRow(this)
            });
        } 
    
        private addCancelButton() {
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.cancelButtonName, class: "cancel" },
                text: "Cancel",
                hint: "Cancel changes",
                icon: "revert",
                visible: false,
                onClick: this.cancelEdit(this)
            });
        }     
    
        private addAddButton() {
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.addButtonName, class: "add" },
                text: "Add",
                hint: "Add new record",
                icon: "plus",
                onClick: this.addRow()
            }); 
        } 
    
        private addEditButton() {
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.editButtonName, class: "edit" },
                text: "Edit",
                hint: "Edit selected record",
                icon: "edit",
                disabled: true,
                onClick: this.editRow()
            }); 
        }   
        
        private addDeleteButton() {
            addButtonToToolbar(this.toolbarOptions, {
                elementAttr: { id: this.deleteButtonName },
                text: "Delete",
                hint: "Delete selected record",
                type: "danger",
                icon: "remove",
                disabled: true,
                onClick: this.deleteRow()
            }); 
        } 
        
        private editRow() {
            return (e: any) => {
                const rowKeys = this.grid.getSelectedRowKeys();
    
                if (rowKeys[0] == null) {
                    DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
                    return;
                }
    
                const rowIndex = this.grid.getRowIndexByKey(rowKeys[0]);
    
                if (rowIndex > -1) {
                    this.grid.editRow(rowIndex);
                    
                    this.gridMode = GridMode.Edit;
                    this.setButtonsVisibility();
                }
    
            }
        }
    
        private deleteRow() {
            return (e: any) => {
                const rowKeys = this.grid.getSelectedRowKeys();
    
                if (rowKeys[0] == null) {
                    DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
                    return;
                }
    
                const rowIndex = this.grid.getRowIndexByKey(rowKeys[0]);
    
                if (rowIndex > -1) {
                    this.grid.deleteRow(rowIndex);
                }
            }
        }    
    
        private saveRow(that: EditButtonsBuilder) {
            return (e: any) => {
                that.grid.saveEditData()
                .done(() => {
                    const unsavedData = that.grid.hasEditData();
                    if (!unsavedData) {
                        that.gridMode = GridMode.Normal;
                        that.setButtonsVisibility();
                    }
                });
            }
        } 
        
        private addRow() {
            return (e: any) => {
                this.gridMode = GridMode.Edit;
                this.setButtonsVisibility();
                this.grid.addRow(); 
            }
        }    
    
        private cancelEdit(that: EditButtonsBuilder) {
            return (e: any) => {
                that.gridMode = GridMode.Normal;
                that.setButtonsVisibility();
                that.grid.cancelEditData(); 
            }
        } 

        private setButtonsVisibility() {
            if (this.gridMode === GridMode.Normal) {
                Areas.showButton(this.addButtonName);
                Areas.showButton(this.editButtonName);
                Areas.showButton(this.deleteButtonName);
                Areas.hideButton(this.saveButtonName);
                Areas.hideButton(this.cancelButtonName);
            } else {
                Areas.hideButton(this.addButtonName);
                Areas.hideButton(this.editButtonName);
                Areas.hideButton(this.deleteButtonName);
                Areas.showButton(this.saveButtonName);
                Areas.showButton(this.cancelButtonName);            
            }
        }

    }
}